{
  "CSServiceForms": {
    "wizard": {
      "steps": {
        "optionalFeedback": {
          "additionalCommentsRequired": {
            "description": "Kirjoita palautteesi tähän",
            "label": "Muu palaute",
            "maxLength": "Enimmäispituus 3 000 merkkiä.",
            "maxlength": "Enimmäispituus 3 000 merkkiä."
          }
        }
      }
    }
  }
}
